module.exports = __webpack_public_path__ + "static/example_2_week-6c595cb684bac66cb7ec53a9df307380.png";